// E.O.N Nutrition — future product concepts. COMING SOON.
// No prices, ingredients, reviews, dosages or health claims (added when formulations are final).
const NUTRITION_IMG = "https://static.prod-images.emergentagent.com/jobs/5eff8c1f-b59e-44ca-87ee-9b0bceebb3f3/images/9947eb39fc362519f83e19506b03cefffc035a634fcbac0f4ab1dc8f7ecad610.jpeg";

export const NUTRITION_CONCEPTS = [
  {
    slug: "eon-boerboel-nutrition",
    name: "E.O.N Boerboel Nutrition",
    category: "Premium Food",
    short: "Premium large-breed dog food concept.",
    philosophy:
      "A future complete nutrition concept being developed with the unique needs of powerful, large-breed dogs in mind — built around structure, energy and long-term wellbeing.",
  },
  {
    slug: "eon-daily-foundation",
    name: "E.O.N Daily Foundation",
    category: "Supplement",
    short: "Daily wellness supplement concept.",
    philosophy:
      "A daily wellness foundation concept intended to support the everyday health of large-breed dogs as part of a balanced routine.",
  },
  {
    slug: "eon-joint-mobility",
    name: "E.O.N Joint + Mobility",
    category: "Supplement",
    short: "Large-breed joint & mobility support concept.",
    philosophy:
      "A joint and mobility support concept designed with the heavy frame of giant breeds in mind, to help them keep moving comfortably through life.",
  },
  {
    slug: "eon-skin-coat",
    name: "E.O.N Skin + Coat",
    category: "Supplement",
    short: "Skin & coat support concept.",
    philosophy:
      "A skin and coat support concept aimed at a healthy skin barrier and the dense, glossy coat of a well-kept Boerboel.",
  },
  {
    slug: "eon-performance",
    name: "E.O.N Performance",
    category: "Supplement",
    short: "Nutrition & support concept for active adult dogs.",
    philosophy:
      "A performance-oriented nutrition and support concept for active, working adult dogs with higher demands.",
  },
  {
    slug: "eon-puppy-foundation",
    name: "E.O.N Puppy Foundation",
    category: "Premium Food",
    short: "Future nutrition concept for growing large-breed puppies.",
    philosophy:
      "A future nutrition concept developed for the careful, steady growth of large-breed puppies during their most important developmental months.",
  },
];

export const NUTRITION_FAQ = [
  { q: "When will E.O.N Nutrition launch?", a: "We're finalizing our formulations. Join the product waitlist to be the first to know launch dates and early access." },
  { q: "Are these products available to buy now?", a: "Not yet — every product is a concept in development and clearly marked Coming Soon. There is no checkout until products officially launch." },
  { q: "Will you share ingredients and details?", a: "Full ingredient panels, guaranteed analysis and product details will be published once formulations are finalized. We won't publish specifics before they're confirmed." },
  { q: "Can businesses carry E.O.N Nutrition?", a: "Yes — breeders, trainers, groomers and pet retailers can join the wholesale waitlist to apply to become an E.O.N Retail Partner at launch." },
];

export const NUTRITION_IMAGE = NUTRITION_IMG;
export const getConcept = (slug) => NUTRITION_CONCEPTS.find((c) => c.slug === slug);
